<template>
  <div class="container-1-subsection">
    <div class="frame-28">
      <p class="text-wrapper-12">Prêt à transformer votre boutique ?</p>
      <p class="text-wrapper-13">
        Rejoignez les fleuristes qui simplifient leur quotidien et développent
        leurs ventes avec Florisuite.
      </p>
      <RouterLink to="/inscription" class="button" aria-label="Commencer votre essai gratuit">
        <div class="text-wrapper-14">Commencer votre essai gratuit</div>
      </RouterLink>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RouterLink } from "vue-router";

export default defineComponent({
  name: "Container1Subsection",
  components: {
    RouterLink,
  },
});
</script>

<style>
.container-1-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #084734;
  border: 0px none;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 100px 30px;
  position: relative;
  width: 100%;
}

.container-1-subsection .frame-28 {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 59px;
  justify-content: center;
  max-width: 894px;
  position: relative;
  width: 100%;
}

.container-1-subsection .text-wrapper-12 {
  align-self: stretch;
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 48px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 48px;
  margin-top: -1.00px;
  position: relative;
  text-align: center;
}

.container-1-subsection .text-wrapper-13 {
  align-self: stretch;
  color: #ffffff;
  font-family: "Montserrat", Helvetica;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 28px;
  position: relative;
  text-align: center;
}

.container-1-subsection .button {
  all: unset;
  align-items: center;
  background-color: #ffffff;
  border: 0px none;
  border-radius: 8px;
  box-shadow: 0px 0px 0px transparent, 0px 1px 2px #0000000d;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  max-width: 400px;
  overflow: hidden;
  position: relative;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  width: 100%;
}

.container-1-subsection .button:hover {
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.16);
  transform: translateY(-1px);
}

.container-1-subsection .button:active {
  transform: translateY(0px);
}

.container-1-subsection .button:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.8);
  outline-offset: 3px;
  border-radius: 10px;
}

.container-1-subsection .text-wrapper-14 {
  color: #084734;
  font-family: "Open Sans", Helvetica;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  padding: 0 16px;
  position: relative;
  text-align: center;
  white-space: normal;
}

@media (max-width: 1024px) {
  .container-1-subsection {
    padding: 80px 24px;
  }

  .container-1-subsection .frame-28 {
    gap: 40px;
  }

  .container-1-subsection .text-wrapper-12 {
    font-size: 40px;
    line-height: 44px;
  }
}

@media (max-width: 768px) {
  .container-1-subsection {
    padding: 64px 20px;
  }

  .container-1-subsection .frame-28 {
    gap: 28px;
  }

  .container-1-subsection .text-wrapper-12 {
    font-size: 32px;
    line-height: 36px;
  }

  .container-1-subsection .text-wrapper-13 {
    font-size: 18px;
    line-height: 26px;
  }

  .container-1-subsection .text-wrapper-14 {
    font-size: 16px;
    line-height: 24px;
  }
}

@media (max-width: 480px) {
  .container-1-subsection {
    padding: 52px 16px;
  }

  .container-1-subsection .text-wrapper-12 {
    font-size: 26px;
    line-height: 30px;
  }

  .container-1-subsection .text-wrapper-13 {
    font-size: 16px;
    line-height: 24px;
  }

  .container-1-subsection .button {
    min-height: 44px;
    height: auto;
    padding: 8px 0;
  }
}
</style>
